import React, { useCallback } from 'react';
import { styled } from 'baseui';
import { Modal, ROLE as MODAL_ROLE, SIZE as MODAL_SIZE } from 'baseui/modal';
import noop from 'lodash/noop';
import { useDeleteHandler as useDeleteAnnotationHandler } from '../annotation-details/hooks/use-delete-handler';
import { useDeleteHandler as useDeleteAllAnnotationsHandler } from '../annotation-header/hooks/use-delete-handler';
import { AnnotationLabeledList } from '../annotations-common/annotation-labeled-list';
import { DeleteAllAnnotationsConfirmationModal } from '../common/delete-all-annotations-confirmation-modal';
import { EmptyState } from '../common/empty-state';
import { useFilteredAnnotations } from '../hooks/use-filtered-annotations';
import { useSidePanel } from '../side-panel-provider';
import { AnnotationDetailsHeader } from './annotation-details-header';
import { AnnotationDetailsItem } from './annotation-details-item';
import type { AnnotationInfoT, HeaderInfoT } from './types';
const ListContainer = styled('div', {
  height: '100%',
  width: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column'
});
export const AnnotationList = () => {
  const annotations = useFilteredAnnotations();
  const {
    deleteAnnotationModalContentComponent
  } = useSidePanel();
  const {
    handleDeleteAnnotation,
    deleteModalProps: deleteAnnotationModalProps
  } = useDeleteAnnotationHandler();
  const {
    handleDeleteAllAnnotations,
    deleteModalProps: deleteAllAnnotationsModalProps
  } = useDeleteAllAnnotationsHandler();
  const hasAnnotations = annotations.length > 0;
  const shouldShowDeleteAnnotationModal = !!deleteAnnotationModalContentComponent;
  const deleteAllAnnotationsProps = deleteAllAnnotationsModalProps.isOpen ? deleteAllAnnotationsModalProps : {
    isOpen: false,
    label: '',
    onCancel: noop,
    onConfirm: () => Promise.resolve()
  };
  const header = useCallback((headerInfo: HeaderInfoT, label: string, icon: React.ReactNode) => <AnnotationDetailsHeader headerInfo={headerInfo} label={label} icon={icon} onDeleteAllAnnotations={() => handleDeleteAllAnnotations(label)} />, [handleDeleteAllAnnotations]);
  const annotationListItem = useCallback((annotation: AnnotationInfoT, isFocused: boolean, icon: React.ReactNode) => <AnnotationDetailsItem annotation={annotation} icon={icon} isFocused={isFocused} onDeleteAnnotation={() => handleDeleteAnnotation(annotation)} />, [handleDeleteAnnotation]);
  if (!hasAnnotations) {
    return <EmptyState size={50} message="No annotations found. Add annotations or adjust your filters." />;
  }
  return <>
      <ListContainer>
        <AnnotationLabeledList annotations={annotations} importedAnnotationIds={[]} header={header} item={annotationListItem} />
      </ListContainer>

      {shouldShowDeleteAnnotationModal && <Modal onClose={deleteAnnotationModalProps.isOpen ? deleteAnnotationModalProps.onCancel : undefined} closeable isOpen={deleteAnnotationModalProps.isOpen} animate autoFocus size={MODAL_SIZE.default} role={MODAL_ROLE.dialog}>
          {deleteAnnotationModalProps.isOpen && deleteAnnotationModalContentComponent({
        onCancel: deleteAnnotationModalProps.onCancel,
        onSubmit: deleteAnnotationModalProps.onSubmit,
        annotationId: deleteAnnotationModalProps.annotationId
      })}
        </Modal>}

      <DeleteAllAnnotationsConfirmationModal {...deleteAllAnnotationsProps} />
    </>;
};